import type { FC } from "react";
import { useDispatch } from "react-redux";
import { TriggerButton } from "widgets";

import { useError } from "@/app-utils/graphql/useError.ts";
import { type FileDownloadQuery, useFileDownloadQuery } from "@/modules/files/graphql/files-queries.gql";
import { downloadProjectFile } from "@/redux/modules/files.ts";
import type { ReduxDispatch } from "@/redux/redux-utils.ts";
import { FILE_BROWSE_TYPES } from "@/settings/settings.ts";
import type { Either } from "@/types";

interface DownloadByIdProps {
  fileId: number;
}

interface DownloadByFileProps {
  file: FileDownloadQuery["projectFileById"];
}

/**
 * {@link TriggerButton} to download (single) project files. Download of multiple
 * files is yet not supported.
 * @param props fileId
 * @constructor
 */
export const FileDownloadButton: FC<Either<DownloadByIdProps, DownloadByFileProps>> = ({ fileId, file }) => {
  const dispatch = useDispatch<ReduxDispatch>();
  const { data, error } = useFileDownloadQuery({ variables: { fileId: fileId ?? -1 }, skip: !fileId });
  void useError(error);

  const downloadableFile: FileDownloadQuery["projectFileById"] | null | undefined = file ?? data?.projectFileById;

  return downloadableFile?.fileBrowseType === FILE_BROWSE_TYPES.REGULAR_FILE ? (
    <TriggerButton
      onPress={() => dispatch(downloadProjectFile(downloadableFile))}
      icon={"download"}
      key={`file-download-button-${downloadableFile.id}`}
      label={"Download"}
      showLabel
    />
  ) : null;
};
